export default __webpack_public_path__ + "static/media/svg-6.c44126dd.svg";